export default __webpack_public_path__ + "static/media/loadingman.a8f0a59f.png";